import { useState, useEffect } from "react";
import "./AppHeader.css";
import { AppSearch } from "../app-search/AppSearch";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../../redux/features/appData";

type AppHeaderProps = {
   
}

export const AppHeader = ({} : AppHeaderProps) => {

    const uiStates = useSelector(selectUIStates);

    return (
        <>
            <div className="app-header">
                <div className="app-header-location">
                    {uiStates.hrisLocation}
                </div>
                <AppSearch />
            </div>
        </>

    )
}